import React from "react";
import style from "../../../assets/scss/common/modal/organInfoModal.module.scss";
import {Trans, useTranslation} from "react-i18next";
import {useLanguage} from "../../../hooks/hooks";
import copyIcon from "../../../assets/images/icons/copy_icon.svg";
import kpassLogo from "../../../assets/images/icons/kpass_mini_logo.svg";
import dcasLogo from "../../../assets/images/icons/dcas_mini_logo.svg";

interface OrganInfoModalProps {
  isOpen: boolean;
  onClose: () => void;
  name: string;
  organSignInCode: string;
  organName: string;
  organPhoneNumber: string;
  organVoucherCnt: number;
  organKpassVoucherCnt: number;
  organDcasVoucherCnt: number;
}

const OrganInfoModal: React.FC<OrganInfoModalProps> = ({
  isOpen,
  onClose,
  name,
  organSignInCode,
  organName,
  organPhoneNumber,
  organVoucherCnt,
  organKpassVoucherCnt,
  organDcasVoucherCnt,
}) => {
  const { t } = useTranslation("profileInfo");
  const { isKorean } = useLanguage();
  if (!isOpen) {
    return null;
  }

  // Function to copy the login code to the clipboard
  const copyToClipboard = async (text: string) => {
    try {
      await navigator.clipboard.writeText(text);
      alert(t("warning.copyLoginCode"));
    } catch (error) {
      console.error("복사 실패:", error);
      alert(t("warning.copyFail"));
    }
  };

  return (
      <div className={style.organInfoModalOverlay}>
        <div className={`${style.organInfoModal} ${isKorean ? "" : style.en}`}>
          <div className={style.organInfoModalContent}>
            <h2 className={style.titleText}>
              <Trans t={t} i18nKey={"organDetail.title"}
                     components={{bold: <span className={style.boldText}/>}}
                     values={{name : name}}/>
            </h2>
          </div>
          <div className={style.organInfoTextContainer}>
            <div className={`${style.infoContainer} ${style.marginBottom1}`}>
              <div className={`${style.infoTitle} ${isKorean ? "" : style.en}`}>
                {t('organDetail.loginCode')}
              </div>
              <div className={style.detailInfoWrapper}>
                <div className={style.detailInfoText}>{organSignInCode}</div>
                <img className={style.copyIcon} src={copyIcon} alt={copyIcon}
                     onClick={() => copyToClipboard(organSignInCode)}
                />
              </div>
            </div>
            <div className={`${style.infoContainer} ${style.marginBottom1}`}>
              <div className={`${style.infoTitle} ${isKorean ? "" : style.en}`}>
                {t('organDetail.organName')}
              </div>
              <div className={style.detailInfoText}>{organName}</div>
            </div>
            <div className={`${style.infoContainer} ${style.marginBottom1}`}>
              <div className={`${style.infoTitle} ${isKorean ? "" : style.en}`}>
                {t('organDetail.organVoucher')}
              </div>
              <div className={`${style.detailInfoText} ${style.infoIconContainer}`}>
                <img src={kpassLogo} alt={kpassLogo} className={style.logoIcon}/>
                {organKpassVoucherCnt}{t('organDetail.unit')}

                <img src={dcasLogo} alt={dcasLogo} className={style.logoIcon}/>
                {organDcasVoucherCnt}{t('organDetail.unit')}
              </div>
            </div>
            <div className={`${style.infoContainer} ${style.marginBottom1}`}>
              <div className={`${style.infoTitle} ${isKorean ? "" : style.en}`}>
                {t('organDetail.managerContact')}
              </div>
              <div className={style.detailInfoText}>{organPhoneNumber}</div>
            </div>
          </div>
          <button onClick={onClose} className={style.organInfoCloseButton}>
            {t('close')}
          </button>
        </div>
      </div>
  );
};

export default OrganInfoModal;
